import { Box, Typography } from "@mui/material";
import { TruncatedText } from "components/TruncatedText";

const InfoWithIcon = ({
    entityName,
    primary,
    secondary,
    startSlot,
    endIcon,
    width,
    size = "default",
}: {
    entityName: string;
    primary?: string;
    secondary?: string;
    startSlot?: React.ReactNode;
    endIcon?: React.ReactNode;
    width?: number;
    size?: "default" | "small";
}) => {
    const isSizeSmall = size === "small";

    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            {startSlot && <Box>{startSlot}</Box>}
            <Box sx={{ maxWidth: width }}>
                <TruncatedText width={width} sx={{ fontSize: isSizeSmall ? 14 : 16, color: "text.primary" }}>
                    {entityName}
                </TruncatedText>
                {primary && (
                    <Typography
                        sx={{
                            fontSize: isSizeSmall ? 12 : 14,
                            fontWeight: isSizeSmall ? 600 : 400,
                            color: "text.disabled",
                            marginBottom: isSizeSmall ? 0 : -0.25,
                        }}
                    >
                        {primary}
                    </Typography>
                )}
                {secondary && <Typography sx={{ fontSize: 14, color: "text.disabled" }}>{secondary}</Typography>}
            </Box>
            {endIcon && <Box ml={1}>{endIcon}</Box>}
        </Box>
    );
};

export default InfoWithIcon;
